import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-status-chip',
  imports: [
    CommonModule,
    MatIconModule
  ],
  templateUrl: './status-chip.component.html',
  styleUrl: './status-chip.component.scss'
})
export class StatusChipComponent {

    @Input() status: string = '';

  getChipClasses(): string {
    const base = 'flex items-center gap-1 px-3 py-1 rounded-full text-sm font-medium mr-1';
    switch (this.status.toLowerCase()) {
      case 'solicitado':
        return `${base} bg-[#643F00] text-[#FFDDB6]`;
      case 'confirmado':
        return `${base} bg-[#00325A] text-[#D2E4FF]`;
      case 'cancelado':
        return `${base} bg-[#72333C] text-[#FFD9DC]`;
      case 'en progreso':
        return `${base} bg-[#0C5130] text-[#AFF1C4]`;
      case 'finalizado':
        return `${base} bg-[#001D33] text-[#CFE5FF]`;
      case 'rechazado':
        return `${base} bg-[#3F484A] text-[#DBE4E6]`;
      default:
        return ``;
    }
  }

  getIcon(): string {
    switch (this.status.toLowerCase()) {
      case 'solicitado': return 'schedule';
      case 'confirmado': return 'check_circle';
      case 'cancelado': return 'cancel';
      case 'en progreso': return 'autorenew';
      case 'finalizado': return 'task_alt';
      case 'rechazado': return 'block';
      default: return '...';
    }
  }
}
